<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Plan Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="edit()">Edit Plan</button>
                </div>
            </div>
            <div class="table-responsive" v-show="plan">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{plan.packageId}}</td>
                    </tr>
                    <tr>
                        <th>name</th>
                        <td>{{plan.name}}</td>
                    </tr>
                    <tr>
                        <th>Amount</th>
                        <td>{{plan.amount}}</td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>{{plan.type}}</td>
                    </tr>
                    <tr>
                        <th>description</th>
                        <td>{{plan.description}}</td>
                    </tr>

                    <tr>
                        <th>Start Date</th>
                        <td>{{plan.startDate}}</td>
                    </tr>
                    <tr>
                        <th>End Date</th>
                        <td>{{plan.endDate}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>
                            <span class="badge badge-success" v-if="plan.active"> Active </span>
                            <span class="badge badge-danger" v-else> Inactive </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'PlanDetails',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GET_SELECTED_PLAN', this.$route.params.id)
                .then((res) => {
                    if(this.plan && this.plan.active == null) this.plan.active = 0;
                    console.log("GET_SELECTED_PLAN res : ", res)
                })
                .catch((err) => {
                    console.log("GET_SELECTED_PLAN err : ", err)
                })
    },
    data () {
        return {
        }
    },
    methods: {
        edit(){
            this.$router.push({ name: 'Edit Plan', params: { id: this.plan.packageId}})
        },
    },
    computed: {
        ...mapGetters([ 'selectedPlan']),
        plan(){
            return this.selectedPlan
        }
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plans/PlanDetails.vue